import React, { useEffect, useState } from 'react'
import { Season } from '../../constants/enums/Season'
import './Imageshiftperseason.scss'

type Props = {
	children?: React.ReactNode
}

const seasonImageMap: Record<Season, string[]> = {
	[Season.Spring]: [
		'/img/background-images/spring1.jpg'
	],
	[Season.Summer]: [
		'/img/background-images/summer1.jpg',
		'/img/background-images/summer2.jpg',
	],
	[Season.Autumn]: [
		'/img/background-images/autumn1.jpg',
		'/img/background-images/autumn2.jpg',
	],
	[Season.Winter]: [
		'/img/background-images/winter1.jpg',
		'/img/background-images/winter2.jpg',
	],
}

const getCurrentSeason = (): Season => {
	const month = new Date().getMonth()
	if (month >= 2 && month <= 4) return Season.Spring
	if (month >= 5 && month <= 7) return Season.Summer
	if (month >= 8 && month <= 10) return Season.Autumn
	return Season.Winter
}

const Imageshiftperseasong: React.FC<Props> = ({ children }) => {
	const season = getCurrentSeason()
	const imagesForSeason = seasonImageMap[season]
	const [currentImage, setCurrentImage] = useState(imagesForSeason[0])

	useEffect(() => {
		let interval: NodeJS.Timeout | undefined

		if (imagesForSeason.length > 1) {
			interval = setInterval(() => {
				setCurrentImage((prev) => {
					const currentIndex = imagesForSeason.indexOf(prev)
					const nextIndex =
						(currentIndex + 1) % imagesForSeason.length
					return imagesForSeason[nextIndex]
				})
			}, 15000) // how long time do th ebussiness want the interval to be
		}

		return () => {
			if (interval) clearInterval(interval)
		}
	}, [imagesForSeason])

	return (
		<div
			id="season-background"
			className="season-bg"
			style={{
				backgroundImage: `url(${currentImage}), url('/img/background-images/fallback.jpg')`,
			}}>
			<div className="season-bg-overlay">{children}</div>
		</div>
	)
}
export default Imageshiftperseasong